/**
 * Client for the admin-api edge function: the cockpit's secret-holding
 * orchestrator (Stripe reads, GDPR export/deletion, session repair,
 * welcome resend, tracker revalidation). Auth is the caller's JWT;
 * the function verifies is_admin() server-side.
 */
import { supabase } from './supabase';

const FN_URL = `${import.meta.env.VITE_SUPABASE_URL as string}/functions/v1/admin-api`;

export async function adminApi<T = Record<string, unknown>>(
  action: string,
  body: Record<string, unknown> = {},
): Promise<T> {
  const { data: { session } } = await supabase.auth.getSession();
  if (!session) throw new Error('not signed in');
  const res = await fetch(FN_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${session.access_token}`,
      apikey: import.meta.env.VITE_SUPABASE_ANON_KEY as string,
    },
    body: JSON.stringify({ action, ...body }),
  });
  const d = await res.json().catch(() => ({}));
  if (!res.ok) {
    const detail = d?.detail ? (typeof d.detail === 'string' ? d.detail : JSON.stringify(d.detail)) : '';
    throw new Error(d?.error ? `${d.error}${detail ? `: ${detail}` : ''}` : `request failed (${res.status})`);
  }
  return d as T;
}

/** Download a JSON payload as a file in the browser. */
export function downloadJson(payload: unknown, filename: string) {
  const blob = new Blob([JSON.stringify(payload, null, 2)], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}
